module.exports = __webpack_public_path__ + "static/media/superscript.ef571e08.svg";